module.exports = __webpack_public_path__ + "img/login-bgc-2.fbe88c71.png";